import { generateTestId } from "@client-shared";

export const setDateSelectTestId = (identifier: string): string =>
  generateTestId("DateSelect", identifier.replace(/\s+/g, "-").toLowerCase());

export const setDateSelectMinDateErrorTestId = (identifier: string): string => `${setDateSelectTestId(identifier)}-min-date-error`;

export const setDateSelectMaxDateErrorTestId = (identifier: string): string => `${setDateSelectTestId(identifier)}-max-date-error`;
